module.exports = __webpack_public_path__ + "img/saas.276fd4e2.png";